import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { NotificationBell } from "@/components/layout/NotificationBell";

export function Header({ fullName, avatarUrl }: { fullName: string; avatarUrl: string }) {
  return (
    <header className="sticky top-0 z-20 border-b border-white/5 bg-black/95 backdrop-blur-sm md:top-0">
      <div className="mx-auto flex h-14 w-full min-w-0 max-w-7xl items-center justify-end gap-2 px-3 sm:h-16 sm:gap-3 sm:px-4 md:px-6">
        <NotificationBell />
        <div className="min-w-0 max-w-[40vw] text-right sm:max-w-none">
          <p className="truncate text-sm font-medium text-white">{fullName}</p>
          <p className="hidden text-xs text-slate-400 sm:block">Administrator</p>
        </div>
        <Avatar className="h-8 w-8 shrink-0 sm:h-10 sm:w-10">
          <AvatarImage src={avatarUrl} />
          <AvatarFallback className="text-xs sm:text-sm">{fullName.slice(0, 1).toUpperCase()}</AvatarFallback>
        </Avatar>
      </div>
    </header>
  );
}

